$(document).on("turbolinks:load", function () {
  if ($('.js-resource-type-select').is('*')) {
    $('.js-resource-type-select').on('change', function(){
      var type = $(this).find(":selected").val();
      var roomSettings = $('.js-room-settings');
      var kennelSettings = $('.js-kennel-settings');

      if (type == 'room') {
        roomSettings.find('input').prop('disabled', false);
        roomSettings.slideDown('fast');

        kennelSettings.slideUp('fast');
        kennelSettings.find('input').prop('disabled', true);
      } else {
        roomSettings.slideUp('fast');
        roomSettings.find('input').prop('disabled', true);

        kennelSettings.find('input').prop('disabled', false);
        kennelSettings.slideDown('fast');
      }
    });
  }
});
